module.exports = __webpack_public_path__ + "img/thumbnail_AfricanBuffalo_f_normal.b67c7a3d.png";